var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("AppNavigationSettings", { attrs: { title: _vm.settingsTitle } }, [
    _c(
      "ul",
      { staticClass: "settings-fieldset-interior" },
      [
        _c("SettingsImportSection", {
          attrs: { "is-disabled": _vm.loadingCalendars }
        }),
        _vm._v(" "),
        _c(
          "ActionCheckbox",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: {
              checked: _vm.birthdayCalendar,
              disabled: _vm.isBirthdayCalendarDisabled
            },
            on: { "update:checked": _vm.toggleBirthdayEnabled }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Enable birthday calendar")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ActionCheckbox",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: { checked: _vm.showPopover, disabled: _vm.savingPopover },
            on: { "update:checked": _vm.togglePopoverEnabled }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Enable simplified editor")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ActionCheckbox",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: { checked: _vm.eventLimit, disabled: _vm.savingEventLimit },
            on: { "update:checked": _vm.toggleEventLimitEnabled }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Limit visible events per view")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ActionCheckbox",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: { checked: _vm.showWeekends, disabled: _vm.savingWeekend },
            on: { "update:checked": _vm.toggleWeekendsEnabled }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Show weekends")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ActionCheckbox",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: {
              checked: _vm.showWeekNumbers,
              disabled: _vm.savingWeekNumber
            },
            on: { "update:checked": _vm.toggleWeekNumberEnabled }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Show week numbers")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "li",
          {
            staticClass:
              "settings-fieldset-interior-item settings-fieldset-interior-item--slotDuration"
          },
          [
            _c("Multiselect", {
              attrs: {
                "allow-empty": false,
                options: _vm.slotDurationOptions,
                value: _vm.selectedDurationOption,
                disabled: _vm.savingSlotDuration,
                "track-by": "value",
                label: "label"
              },
              on: { select: _vm.changeSlotDuration }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("SettingsTimezoneSelect", {
          attrs: { "is-disabled": _vm.loadingCalendars }
        }),
        _vm._v(" "),
        _c(
          "ActionButton",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: { icon: "icon-clippy" },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.copyPrimaryCalDAV($event)
              }
            }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Copy primary CalDAV address")) +
                "\n\t\t"
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "ActionButton",
          {
            staticClass: "settings-fieldset-interior-item",
            attrs: { icon: "icon-clippy" },
            on: {
              click: function($event) {
                $event.preventDefault()
                $event.stopPropagation()
                return _vm.copyAppleCalDAV($event)
              }
            }
          },
          [
            _vm._v(
              "\n\t\t\t" +
                _vm._s(_vm.$t("calendar", "Copy iOS/macOS CalDAV address")) +
                "\n\t\t"
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }